import EventEmitter from 'EventEmitter';

const events = {
  CHECK_CAPACITY: '@assignment/CHECK_CAPACITY',
  ASSIGN_ITINERARY: '@assignment/ASSIGN_ITINERARY',
};

const AssignmentEventEmitter = new EventEmitter();

export default AssignmentEventEmitter;
export { events };
